import {
  LISTS_FETCH,
  LISTS_FETCH_SUCCESS,
  LISTS_FETCH_FAILURE,
  LIST_DATA_FETCH,
  LIST_DATA_FETCH_SUCCESS,
  LIST_DATA_FETCH_FAILURE,
} from "../actionTypes";

const INITIAL_STATE = {
  lists: [],
  listData: {},
  loading: false,
  error: null,
};

export default function ListsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case LISTS_FETCH:
      return { ...state, lists: [], loading: true, error: null };
    case LIST_DATA_FETCH:
      return { ...state, listData: {}, loading: true, error: null };
    case LISTS_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        lists: payload,
        loading: false,
        error: null,
      };
    }
    case LIST_DATA_FETCH_SUCCESS: {
      const { payload } = action;
      return {
        ...state,
        listData: payload,
        loading: false,
        error: null,
      };
    }
    case LISTS_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    case LIST_DATA_FETCH_FAILURE: {
      const { payload } = action;
      return { ...state, loading: false, error: payload };
    }
    default:
      return state;
  }
}
